import React, { useState } from "react";
import { Box, Modal, Slide } from "@mui/material";
import CheckWithDateMobileV2 from "../CheckWithDateMobileV2";
import ViewButtonMobileV2 from "../Buttons/ViewButtonMobileV2";
import ViewGeneralLiabilityMobileV2 from "../forms/ViewGeneralLiabilityMobileV2";
import AddButtonRoundMobileV4 from "../Buttons/AddButtonRoundMobileV4";

function FormLine3NoMarginV2Mobile(props) {
  const [showViewModal3, setShowViewModal3] = useState(false);

  const openViewModal3 = () => {
    setShowViewModal3(true);
  };

  const closeViewModal3 = () => {
    setShowViewModal3(false);
  };

  console.log("showViewmodal3:", showViewModal3);

  return (
    <div
      style={{
        marginLeft: "0px",
        display: "flex",
        flexDirection: "row",
        height: "30px",
        borderRadius: "30px",
        border: "1px solid lightgrey",
        width: "100%",
        marginTop: "5px",
        marginBottom: "5px",
        paddingLeft: "15px",
        paddingRight: "5px",
      }}
    >
      <Modal open={showViewModal3} onClose={closeViewModal3}>
        <Slide direction="left" in={showViewModal3}>
          <Box
            sx={{
              position: "fixed",
              top: "5%",
              right: 0,
              width: "90%",
              height: "90%",
              minHeight: "90%",
              bgcolor: "background.paper",
              boxShadow: 24,
              marginRight: "15px",
              pl: 0,
              pr: 0,
              borderRadius: "15px",
              display: "flex",
              flexDirection: "column",
              zIndex: "1",
            }}
          >
            <ViewGeneralLiabilityMobileV2
              {...props}
              closemodal={closeViewModal3}
            />
          </Box>
        </Slide>
      </Modal>
      <div
        style={{
          width: "50%",
          fontSize: "13px",
          fontWeight: "600",
          display: "flex",
          justifyContent: "flex-start",
          alignContent: "center",
          alignItems: "center",
        }}
      >
        {props.title}
      </div>
      <div
        style={{
          width: "35%",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        {props.signed ? (
          <CheckWithDateMobileV2 checked={true} content={props.date} />
        ) : (
          <CheckWithDateMobileV2 checked={false} content="Not signed" />
        )}
      </div>
      <div
        style={{
          width: "15%",
          display: "flex",
          justifyContent: "flex-end",
          alignContent: "flex-end",
          alignItems: "flex-end",
        }}
      >
        {props.signed ? (
          <ViewButtonMobileV2 handleOpen2={openViewModal3} {...props} />
        ) : (
          <AddButtonRoundMobileV4 handleOpen={props.handleOpen} />
        )}
      </div>
    </div>
  );
}

export default FormLine3NoMarginV2Mobile;
